import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description?: string;
  keywords?: string;
  path?: string;
}

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

/**
 * 页面级 SEO：设置 document.title、description、keywords、canonical、og / twitter 标签。
 */
export function usePageMeta({ title, description = "", keywords = "", path = "/" }: MetaOptions) {
  useEffect(() => {
    const site = "https://0ac9g.cn";
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
    const url = `${site}${path}`;
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    setMeta("property", "og:url", url);
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
  }, [title, description, keywords, path]);
}

export function injectJsonLd(data: object) {
  const el = document.createElement("script");
  el.type = "application/ld+json";
  el.setAttribute("data-page-jsonld", "1");
  el.textContent = JSON.stringify(data);
  document.head.appendChild(el);
  return el;
}

export function clearPageJsonLd() {
  document.head.querySelectorAll('script[data-page-jsonld="1"]').forEach((n) => n.remove());
}